import { PaymentMethod } from '../models/Organization';
import { PaymentStatus, RoomBookingStatus } from '../models/RoomBooking';

function normalizedStatus(status: string | null | undefined): string {
  return status?.toString().toUpperCase() ?? '';
}

function normalizedPaymentStatus(
  paymentStatus: PaymentStatus | string | null | undefined,
): string {
  return paymentStatus?.toString().toUpperCase() ?? '';
}

function isConfirmedRoomBookingStatus(status: string | null | undefined): boolean {
  const normalized = normalizedStatus(status);
  return (
    normalized === RoomBookingStatus.CONFIRMED_BY_HOST ||
    normalized === RoomBookingStatus.AUTO_CONFIRMED ||
    normalized === 'CONFIRMED'
  );
}

function isConfirmedTutorBookingStatus(status: string | null | undefined): boolean {
  return normalizedStatus(status) === 'CONFIRMED';
}

/** Host: mark cash room booking paid when confirmed and still waiting on site. */
export function canCollectRoomBookingPayment(booking: {
  status: string;
  paymentMethod?: PaymentMethod | string | null;
  paymentStatus?: PaymentStatus | string | null;
}): boolean {
  if (!isConfirmedRoomBookingStatus(booking.status)) {
    return false;
  }
  if (booking.paymentMethod?.toString().toUpperCase() !== PaymentMethod.CASH) {
    return false;
  }
  return normalizedPaymentStatus(booking.paymentStatus) === PaymentStatus.TO_BE_PAID_ON_SITE;
}

/**
 * Host/tutor: mark on-site tutor booking paid once confirmed.
 * Tutor booking responses do not expose paymentMethod; TO_BE_PAID_ON_SITE is the gate.
 */
export function canCollectTutorBookingPayment(booking: {
  status: string;
  paymentStatus?: PaymentStatus | string | null;
}): boolean {
  if (!isConfirmedTutorBookingStatus(booking.status)) {
    return false;
  }
  return normalizedPaymentStatus(booking.paymentStatus) === PaymentStatus.TO_BE_PAID_ON_SITE;
}
